import React from 'react';
import { Title, Icon, Text, Button, Divider, Flex, Container } from '@homeexchange/design';
import i18n from '../../../i18n';
import Utils from '../../../utils/utils';
import { HomeEditPanelContact } from '../../home/edit/HomeEditPanelContact';
var UserCompletedVerification = function (_a) {
    var user = _a.user;
    var getFirstVerifiedHome = function () {
        var homes = user.get('homes');
        return homes[0];
    };
    var home = getFirstVerifiedHome();
    return (React.createElement(Container, { className: "container user-completed-verification", isFluid: true },
        React.createElement(Flex, { className: "verification-content", direction: "column" },
            React.createElement(Flex, { direction: "column", gap: "2" },
                React.createElement(Title, { className: "verification-title", isImpact: true, hasHeaderTag: true, level: 2 },
                    i18n.t('user:verification.done.title'),
                    React.createElement(Icon, { name: "BadgeCheckFill", color: "secondary", size: "2xl", className: "success-icon" })),
                React.createElement(Text, null, i18n.t('user:page_verification_verified_subheader'))),
            React.createElement(Flex, { direction: "column", gap: "2" },
                React.createElement(Text, { className: "verification-subtitle" }, i18n.t('user:page.verifPage.verified.changePref.title')),
                React.createElement(Text, { className: "verification-bloc-text" }, i18n.t('user:page.verifPage.verified.changePref.desc')),
                home && (React.createElement(Button, { className: "no-underline", hierarchy: "secondary", size: "medium", href: "".concat(i18n.t('url:home_edit', { id: home.id }), "#").concat(Utils.slugify(HomeEditPanelContact.title)) }, i18n.t('user:verification.done.preferences.button')))),
            React.createElement(Divider, { className: "verification-divider" }),
            React.createElement(Flex, { direction: "column", gap: "2" },
                React.createElement(Text, { className: "verification-subtitle" }, i18n.t('user:page.verifPage.verified.search.title')),
                React.createElement(Text, { className: "verification-bloc-text" }, i18n.t('user:page.verifPage.verified.search.desc')),
                React.createElement(Button, { className: "no-underline", hierarchy: "secondary", size: "medium", href: "".concat(i18n.t('url:search-v2'), "everywhere") }, i18n.t('user:verification.done.browse-homes.button'))))));
};
export default UserCompletedVerification;
